"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PageMedia = _interopRequireDefault(require("../PageMedia/PageMedia"));
var _EventOccurrenceTop = _interopRequireDefault(require("./EventOccurrenceTop/EventOccurrenceTop"));
var _SIAinFormEventPrices = _interopRequireDefault(require("./SIAinFormEventPrices/SIAinFormEventPrices"));
var _EventSpeaker = _interopRequireDefault(require("./EventSpeaker/EventSpeaker"));
var _GoBackButton = _interopRequireDefault(require("../GoBackButton/GoBackButton"));
var _LogoLink = _interopRequireDefault(require("../LogoLink/LogoLink"));
var _TextWithSyllabification = _interopRequireDefault(require("../TextWithSyllabification/TextWithSyllabification"));
var _SIACMSContent = _interopRequireDefault(require("../SIACMSContent/SIACMSContent"));
var _OccurrenceList = _interopRequireDefault(require("./OccurrenceList/OccurrenceList"));
var _EventOccurrenceList = _interopRequireDefault(require("../../EventOccurrenceList/EventOccurrenceList"));
var _DownloadLink = _interopRequireDefault(require("../DownloadLink/DownloadLink"));
var _Logo = require("../../Logo/Logo");
var _ContentFormatter = require("../../../common/Adapters/CMSAdapter/ContentFormatter");
var _EventDateTimes = _interopRequireDefault(require("./EventDateTimes/EventDateTimes"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-event-occurrence {\n  display: flex;\n  flex-direction: column;\n  max-width: 764px;\n  margin: auto;\n  align-items: center; }\n  .sia-event-occurrence .related-events {\n    width: 66rem; }\n  .sia-event-occurrence .inform-logo {\n    align-self: flex-start;\n    max-width: 369px;\n    max-height: 60px;\n    width: 100%;\n    margin-bottom: 24px; }\n  .sia-event-occurrence .sia-page-bottom {\n    width: 100%; }\n  .sia-event-occurrence .sia-event-occurrence_boxes_area_section-container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 16px;\n    width: 100%; }\n  .sia-event-occurrence .event-speakers {\n    display: grid;\n    grid-template-columns: repeat(2, 2fr);\n    gap: 16px; }\n  .sia-event-occurrence .event-partner {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: auto;\n    max-width: 246px; }\n  .sia-event-occurrence .event-price {\n    align-self: flex-start; }\n  .sia-event-occurrence .info-link {\n    max-width: 390px; }\n  .sia-event-occurrence .occurrence_list {\n    align-self: flex-start;\n    max-width: 100%; }\n\n@media (max-width: 66rem) {\n  .sia-event-occurrence {\n    max-width: 42rem; }\n    .sia-event-occurrence .sia-event-occurrence_boxes_area_section-container {\n      grid-template-columns: 1fr;\n      gap: 8px; }\n    .sia-event-occurrence .sia-page-bottom {\n      padding-inline: 0px; }\n    .sia-event-occurrence .event-partner {\n      padding-right: 16px; }\n    .sia-event-occurrence .related-events {\n      max-width: 100%; } }\n\n@media (max-width: 42rem) {\n  .sia-event-occurrence {\n    padding-inline: 16px; }\n    .sia-event-occurrence .sia-event-occurrence_boxes_area_section-container {\n      grid-template-columns: 1fr;\n      gap: 8px; }\n    .sia-event-occurrence .event-speakers {\n      grid-template-columns: 1fr; }\n    .sia-event-occurrence .related-events {\n      max-width: 100%; } }\n";
  const fileName = "SIAEventOccurrence_SIAEventOccurrence";
  const element = document.querySelector("style[data-sass-component='SIAEventOccurrence_SIAEventOccurrence']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIAEventOccurrence = _ref => {
  let {
    history,
    lang,
    translate,
    formatName,
    status,
    eventOrganisatorName,
    eventLocations,
    eventLanguages,
    eventTitle,
    eventLead,
    eventSublead,
    eventPrice,
    partners,
    media,
    speakers,
    eventPageBottom,
    eventCode,
    eventOccurrences,
    relatedEvents,
    statusLabel,
    hiddeInformLogo = false,
    pictures_gallery,
    core_topics,
    date_times,
    isOrgaEvent = false,
    eventSubleadMultiple
  } = _ref;
  const mediaItem = media?.length > 0 ? media : pictures_gallery ? (0, _ContentFormatter.getMedia)(pictures_gallery) : null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-event-occurrence"
  }, /*#__PURE__*/_react.default.createElement(_GoBackButton.default, {
    history: history,
    lang: lang
  }), !hiddeInformLogo && /*#__PURE__*/_react.default.createElement("div", {
    className: "inform-logo"
  }, /*#__PURE__*/_react.default.createElement(_Logo.Logo, {
    logoType: "inform"
  })), mediaItem?.length > 0 && /*#__PURE__*/_react.default.createElement(_PageMedia.default, {
    items: mediaItem
  }), /*#__PURE__*/_react.default.createElement(_EventOccurrenceTop.default, {
    formatName: formatName,
    status: status,
    statusLabel: statusLabel,
    eventOrganisatorName: eventOrganisatorName,
    eventLocations: eventLocations,
    eventLanguages: eventLanguages,
    eventTitle: eventTitle,
    eventLead: eventLead,
    eventSublead: eventSublead,
    eventSubleadMultiple: eventSubleadMultiple,
    translate: translate,
    core_topics: core_topics,
    lang: lang
  }), eventPageBottom && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-page-bottom"
  }, /*#__PURE__*/_react.default.createElement(_SIACMSContent.default, {
    lang: lang,
    items: eventPageBottom,
    translate: translate
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-event-occurrence_boxes_area_section-container sia-margin-03-top"
  }, speakers && speakers.length && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    className: "title sia-text-07 sia-margin-01-bottom",
    lang: lang
  }, translate('cms.event_occurrence.speaker')), /*#__PURE__*/_react.default.createElement("div", {
    className: "event-speakers"
  }, speakers.map((speaker, index) => /*#__PURE__*/_react.default.createElement(_EventSpeaker.default, {
    key: index,
    lang: lang,
    id: speaker.id,
    picture: speaker.speaker_picture,
    academic_title: speaker.academic_title,
    firstname: speaker.firstname,
    lastname: speaker.lastname,
    diploma_title: speaker.diploma_title,
    work_function: speaker.work_function,
    gender: speaker.gender,
    url: `/${lang}/agenda/speaker/${speaker.id}`
  })))), partners && partners.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "event-partner"
  }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    className: "title sia-text-07 sia-margin-01-bottom",
    lang: lang
  }, translate('cms.event_occurrence.event_partner')), partners.map((partner, index) => partner.src && /*#__PURE__*/_react.default.createElement(_LogoLink.default, {
    key: index,
    src: partner.src,
    href: partner.href,
    width: partner.width,
    height: partner.height
  })))), isOrgaEvent && date_times.length > 0 && /*#__PURE__*/_react.default.createElement(_EventDateTimes.default, {
    translate: translate,
    date_times: date_times,
    lang: lang
  }), eventPrice && eventPrice.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "event-price sia-margin-05-top sia-margin-05-bottom"
  }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    className: "title sia-text-07 sia-margin-01-bottom ",
    lang: lang
  }, translate('cms.event_occurrence.event_price')), /*#__PURE__*/_react.default.createElement(_SIAinFormEventPrices.default, {
    event_price: eventPrice
  })), eventOccurrences && eventOccurrences.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "occurrence_list"
  }, /*#__PURE__*/_react.default.createElement(_OccurrenceList.default, {
    eventCode: eventCode,
    eventOccurrences: eventOccurrences,
    lang: lang,
    translate: translate
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "info-link sia-padding-05-top sia-padding-06-bottom "
  }, /*#__PURE__*/_react.default.createElement(_DownloadLink.default, {
    className: "",
    text: translate('cms.agenda.event_occurrence.info-link'),
    to: `/${lang}/cms/beratung#1385`,
    variant: "INTERNAL"
  }))), relatedEvents && relatedEvents.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "related-events"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-06 sia-padding-01-bottom"
  }, translate('cms.agenda.event_occurrence.similar-events')), /*#__PURE__*/_react.default.createElement(_EventOccurrenceList.default, {
    lang: lang,
    translate: translate,
    eventOccurrences: relatedEvents
  })));
};
SIAEventOccurrence.propTypes = {
  formatName: _propTypes.default.string,
  eventOrganisatorName: _propTypes.default.object,
  eventLocations: _propTypes.default.arrayOf(_propTypes.default.object),
  eventLanguages: _propTypes.default.arrayOf(_propTypes.default.object),
  eventTitle: _propTypes.default.string,
  eventLead: _propTypes.default.string,
  eventSublead: _propTypes.default.string,
  lang: _propTypes.default.string,
  media: _propTypes.default.arrayOf(_propTypes.default.object),
  speakers: _propTypes.default.arrayOf(_propTypes.default.object),
  partners: _propTypes.default.arrayOf(_propTypes.default.object),
  eventPrice: _propTypes.default.array,
  eventPageBottom: _propTypes.default.arrayOf(_propTypes.default.object),
  eventCode: _propTypes.default.string,
  eventOccurrences: _propTypes.default.arrayOf(_propTypes.default.object),
  relatedEvents: _propTypes.default.arrayOf(_propTypes.default.object)
};
var _default = exports.default = SIAEventOccurrence;